import BoothType from "./classes/BoothType";

export const BOOTH_TYPE_ROW = new BoothType('row', 'booth-row', 'boothTypes.row', 3)
export const BOOTH_TYPE_CORNER_RIGHT = new BoothType(
  'corner_right',
  'booth-corner-right',
  'boothTypes.corner_right',
  2
)
export const BOOTH_TYPE_HEAD = new BoothType('head', 'booth-head', 'boothTypes.head', 1)
export const BOOTH_TYPE_CORNER_LEFT = new BoothType(
  'corner_left',
  'booth-corner-left',
  'boothTypes.corner_left',
  2
)
export const BOOTH_TYPE_ISLAND = new BoothType('island', 'booth-island', 'boothTypes.island', 0)
export const BOOTH_TYPE_CORNER = new BoothType(
  'corner',
  'booth-corner',
  'boothTypes.corner',
  2
)

/**
 * @type {Array<BoothType>}
 */
export const BOOTH_TYPES = [
  BOOTH_TYPE_ROW,
  BOOTH_TYPE_CORNER_RIGHT,
  BOOTH_TYPE_HEAD,
  BOOTH_TYPE_CORNER_LEFT,
  BOOTH_TYPE_ISLAND,
  BOOTH_TYPE_CORNER
]

export const UNIT_PC = 'pc'
export const UNIT_SQM = 'sqm'

export const PRINT_CLOUD_STATUS_OPEN = 0
export const PRINT_CLOUD_STATUS_USER_READY = 10
export const PRINT_CLOUD_STATUS_PRINT_READY = 20
export const PRINT_CLOUD_STATUS_OVERDUE = 30
export const PRINT_CLOUD_STATUS_FINISHED = 40

export const ARTICLE_TYPE_DEFAULT = 0
export const ARTICLE_TYPE_PRINTABLE = 10
export const ARTICLE_TYPE_PRINT = 20
export const ARTICLE_TYPE_LETTERING = 21

export const ARTICLE_DEFAULT_IMAGE = '/images/image-placeholder.svg'